import { Suspense } from 'react';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { Skeleton } from '@sara/ui/components/skeleton';
import { TeamListContainerContent } from './TeamListContainerContent';
import type { TeamListContainerProps } from './types';

export type { TeamListContainerProps };

function TeamListSkeleton() {
  return (
    <div className="divide-y divide-border/70 border-y border-border/70">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center justify-between gap-6 py-5">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-64" />
          </div>
          <Skeleton className="h-7 w-24 rounded-full" />
        </div>
      ))}
    </div>
  );
}

export function TeamListContainer(props: TeamListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<TeamListSkeleton />}>
        <TeamListContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
